import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AppSettings } from 'src/app/enums/app-settings.enum';
import { AccountService } from 'src/app/services/account.service';
import { GoogleAnalyticsService } from 'src/app/services/google-analytics.service';
import { ProductService } from 'src/app/services/product.service';
import { SkuDataService } from 'src/app/services/sku-data.service';
import { SubjectService } from 'src/app/services/subject.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ModalController } from '@ionic/angular';
import { SessionDataService } from 'src/app/services/session-data.service';
import { VerificationComponent } from '../verification/verification.component';
import { AdobeAnalyticsService } from 'src/app/services/adobe-analytics.service';
import { LearnMoreTravelInsuranceComponent } from '../learn-more-travel-insurance/learn-more-travel-insurance.component';
import { ProRataPricesModalComponent } from '../pro-rata-prices-modal/pro-rata-prices-modal.component';
import * as moment from 'moment';
import { ApplicationInitializationService } from 'src/app/services/application-initialization.service';
import { ThrowStmt } from '@angular/compiler';
import { SuccessComponent } from '../success/success.component';
import { BogoOfferPopupComponent } from '../bogo-offer-popup/bogo-offer-popup.component';
import { OtpVerificationComponent } from '../otp-verification/otp-verification.component';

@Component({
  selector: 'app-subscribe',
  templateUrl: './subscribe.component.html',
  styleUrls: ['./subscribe.component.scss'],
})
export class SubscribeComponent implements OnInit {
  model: NgbDateStruct;
  public sku: any;
  public agreedOnterms = false;
  public mobileNumber: any;
  public isExpended:Boolean = false;
  public quantity = 1;
  autoRenew: boolean = false;
  public price: string = '';
  currentAccount: any;
  isATPostpaid: boolean;
  countries: any;
  callForwardNumber: any;
  selectedFregement: any = 0;
  sDate: any;
  start: any;
  minDate = {
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    day: new Date().getDate()
  };
  end: any;
  countrycode: any;
  isBridgeSKU: boolean;
  paymentMethod: any;
  categoryDetail: any;
  addon: any;
  smilePointsOfUser: number;
  userInfo: any;
  isArabic: boolean;
  accountId: string;
  LoggedIn = false;
  isUserLoggedIn: boolean = false;
  selectedCategory: any;
  isHomeBound: boolean;
  isprimary: any;
  disabledSmilePoints: boolean = true;
  showSmilesPoints: boolean;
  allowPayWithLoyaltyPaymentMode: boolean = false;
  isControlLine: boolean = false;
  addonCMSUrl: string;
  ismobileScreen: boolean;

  reminderDateTime: any;
  reminderDate: any;
  reminderTime: any;
  reminderAmPm: any;
  timeArray: any = ['12:00', '12:30', '01:00', '01:30', '02:00', '02:30', '03:00', '03:30', '04:00', '04:30', '05:00', '05:30', '06:00'
    , '06:30', '07:00', '07:30', '08:00', '082:30', '09:00', '09:30', '10:00', '10:30', '11:00', '11:30'];

  amPm: any = ['AM', 'PM'];
  currentBalance: number = 0;
  subscribeDisabled: boolean = false;
  AlreadyOpenedVerificationPop: boolean;
  skuAddonDetails: any;
  travelInsuranceAdded: boolean = false;
  isTravelInsuranceAddon: boolean = false;
  proratedData:any[]=[];
  proratadValues:any[]=[];
  lang:any='';
  exists=false;
  subscribedAddonList=[];
  recommendedAddonsSkus: any[];
  userEnv:any;
  openTable = false;
  selectedBogoAddon = null;
  EnableAddonsOtpFlow: any = false;
  isPrimaryAccount:any = "";
  notificationValue:any = "";

  constructor(
    private SKUDS: SkuDataService,
    private UTS: UtilitiesService,
    private ACCS: AccountService,
    private SS: SubjectService,
    private PS: ProductService,
    private cdr: ChangeDetectorRef,
    private GAS: GoogleAnalyticsService,
    private translate: TranslateService,
    private aRoute: ActivatedRoute,
    private modalController: ModalController,
    private SDS: SessionDataService,
    private AAS: AdobeAnalyticsService,
    private appInitService: ApplicationInitializationService,

    private AS: AccountService
  
  ) {
    this.lang = this.UTS.getLocaleLanguage();
    this.proratadValues = this.appInitService?.environmentConfig?.B2C_PRORATA_TOTAL_VALUE;
    this.SS.sku.subscribe((main) => {
      if (main && main.name && main.value) {
        this.addon = main.name;
        this.categoryDetail = main.value;
      }
    });
    this.SS.skuBackendIdDetail.subscribe(x=>{
     if (x!=null)
     {
      if(x?.backendId!=null)
      {
        let subscribedList=JSON.parse(localStorage.getItem('subscribedList'));
        if(subscribedList!=null)
        {
          let filtered=subscribedList?.filter(res=>res==x.backendId);
          if(filtered!=null&&filtered.length>0)
          {
            this.exists=true;
        this.cdr.detectChanges();
          }
          else{
            this.exists=false;
            this.cdr.detectChanges();
          }
        }
     
      }
     }
    })
    this.SS.recommendedAddonsSkus.subscribe((r)=>{ 
      if(r && r.length > 0) {
      this.recommendedAddonsSkus = [];
      this.recommendedAddonsSkus = r;
      for (let i = 0; i < this.recommendedAddonsSkus.length; i++) {
          const skuId = this.recommendedAddonsSkus[i];
          if(skuId == this.sku?.skuId){
            const recommend = {
              recommended : true,
            }
            this.sku = {...this.sku, ...recommend};
          }
        }
      }
    });
  }

  ngOnInit() {
    if (this.appInitService?.environmentConfig?.ENABLE_OTP_AUTHERIZATION_ADDONS &&
      (this.appInitService?.environmentConfig?.ENABLE_OTP_AUTHERIZATION_ADDONS == 'true' || this.appInitService?.environmentConfig?.ENABLE_OTP_AUTHERIZATION_ADDONS == true)) {
      this.EnableAddonsOtpFlow = true;
    }
    // const w = document.documentElement.clientWidth || window.innerWidth;
    // if (w < 992) {
    //   this.ismobileScreen = true;
    // } else {
    //   this.ismobileScreen = false;
    // }
    this.ismobileScreen = this.UTS.isMobileDevice();
    const locale = this.UTS.getLocaleLanguage().toLocaleLowerCase();
    if (locale == 'ar') {
      this.isArabic = true;
    } else {
      this.isArabic = false;
    }
    this.userEnv = this.UTS.getENV();
	if(sessionStorage.getItem('selectedBogoAddon') && sessionStorage.getItem('selectedBogoAddon')!=null){
		this.selectedBogoAddon = JSON.parse(sessionStorage.getItem('selectedBogoAddon'));
	}
  }
  ngDestory() { }

  ngAfterContentInit() {
    this.userInfo = this.ACCS.getUInfo();
    this.selectedCategory = this.SKUDS.getSelectedCategory();
    if (
      this.selectedCategory &&
      this.selectedCategory.categoryId &&
      this.selectedCategory.categoryId == AppSettings.HOME_BOUND
    ) {
      this.isHomeBound = true;
      this.cdr.detectChanges();
    } else {
      this.isHomeBound = false;
      this.cdr.detectChanges();
    }
    this.aRoute.queryParams.subscribe((q) => {
      if (q && q.subCategory) {
        const subCategory = q.subCategory;
        if (subCategory == AppSettings.CONTROL_LINE) {
          this.isControlLine = true;
          if (
            this.selectedCategory &&
            this.selectedCategory.categoryId &&
            this.selectedCategory.categoryId == AppSettings.HOME_BOUND
          ) {
            this.isHomeBound = true;
            this.cdr.detectChanges();
          }
        }
      }
    });
    if (this.userInfo && this.userInfo.mainServiceAccountNo) {
      let count = 0, isBlockCall = false;
      this.SS.currentAccount.subscribe((r) => {
        this.currentAccount = r;
        localStorage.setItem('currentAccount', JSON.stringify(this.currentAccount));
        if (r && localStorage.getItem('currentAccount')) {
          count++;
          const current_user = JSON.parse(localStorage.getItem('currentAccount'));
          this.currentAccount = current_user;
          this.isUserLoggedIn = true;
          this.mobileNumber = this.currentAccount.mobileNumber
            ? this.currentAccount.mobileNumber
            : this.currentAccount.accountNo
              ? this.currentAccount.accountNo
              : ''
                ? this.currentAccount.mobileNumber
                : '';

          this.LoggedIn = true;
          if (count == 1 && isBlockCall == false) {
            isBlockCall = true;
            this.getAccountTypeLogin();
            this.getSmilePoint();
          }
          this.getPrimaryAccountInfo();
        }
      });
    } else {
      this.SS.account.subscribe((r) => (this.mobileNumber = r));
      this.getAccountType();

    }
    this.SS.skuDetails.subscribe((r) => {
      if (r) {
        this.sku = { ...r, ...this.sku };
        if (this.isArabic) {
          this.addonCMSUrl = this.sku?.tAndcAcceptanceAr;
        } else {
          this.addonCMSUrl = this.sku?.tAndcAcceptanceEn;
        }
        if((r?.vasIsEligibleForAccountType && r?.vasIsEligibleForAccountType == 'POSTPAID') || (r?.vasIsEligibleForAccountType && r?.vasIsEligibleForAccountType == '1')){
          this.getProratedDetails(r);
        }
        this.cdr.detectChanges();
      }
      if (this.sku && this.sku.listPrice) {
        this.getPrice();
      }
      if (
        (this.sku && this.sku.skuId == AppSettings.ETISALAT_EBRIDGE_LITE) ||
        this.sku.skuId == AppSettings.ETISALAT_EBRIDGE_PREIMUM
      ) {
        this.isBridgeSKU = true;
        this.getCountries();
      } else {
        this.isBridgeSKU = false;
      }
      if (this.sku && this.sku.allowPayWithLoyaltyPaymentMode) {
        this.allowPayWithLoyaltyPaymentMode = true;
      }
	  this.getSkuAddonDetailRoaming(this.sku.skuId);
    });
  }

  increase() {
    if (this.sku && this.sku.maxQuantity) {
      if (this.sku.maxQuantity > this.quantity) {
        this.quantity++;
        this.getPrice();
      }
    }
  }

  decrease() {
    if (this.sku && this.sku.maxQuantity) {
      if (this.quantity > 1) {
        this.quantity--;
        this.getPrice();
      }
    }
  }

  changeToggle(e: any) {
    this.autoRenew = !this.autoRenew;
  }
  onCheckoutImpression()
  {
    let product=[{
      name: this.sku?.displayName,
      id:  this.sku?.id ? this.sku.id : this.sku.skuId ? this.sku.skuId : '',
      price: +this.sku?.listPrice,
      brand:this.sku?.brand,
      category:'Roaming',
      user_env:this.UTS.getENV(),
      variant:'black',
      quantity:1
    }];

    let modal_data={
      event:'checkout',
      user_env: this.UTS.getENV(),
      ecommerce:{
        checkout:{
          actionField:{step:1, option:'Pass Selected Payment Option'},
          products:product
        }
     
      }
    }
    this.GAS.productClick_RoamingType(modal_data);
  }
  selectTime(time: any) {
    this.reminderTime = time;
  }
  selectAmPm(amPm: any) {
    this.reminderAmPm = amPm;
  }
  addAddon() {
    this.UTS.clearError();
    let link = '/addAddons';
    if (this.paymentMethod == 2) {
      if (parseInt(this.price) > this.smilePointsOfUser) {
        this.UTS.error('Error! Not Enough Smile Points');
        return;
      }
    }
    let specialInput = []; //this.sku.specialInput ? this.sku.specialInput :
    localStorage.setItem('mobileNumber', this.mobileNumber);
    const payload = {
      accountNo: this.mobileNumber,
      accountNumber: null,
      addonId: this.sku.skuId,
      skuid: null,
      validate: false,
      type: this.autoRenew == true ? 'AUTO_RENEWAL' : 'ONE_TIME',
      quantity: this.quantity,
      specialInputs: specialInput,
      locale: this.UTS.getLocaleLanguage().toString().toLocaleUpperCase(),
      forwardCountryCode: null,
      forwardCountryNumber: null,
      reminder_date_time: null,
      gamingAddon: false
    }
    const subCategoryId = localStorage.getItem('subCategoryId'); 
    const ocrResponse = JSON.parse(localStorage.getItem('OCR_RESPONSE'));
    if(this.sku && this.sku?.productType  && this.sku?.productType  == AppSettings.KIDS_ADDONS && ocrResponse && ocrResponse?.documentId){
      payload['kidEIDNumber'] = ocrResponse?.documentId;
      payload.specialInputs.push({
        fieldName: 'kidEIDNumber',
        fieldValue: ocrResponse?.documentId,
      })
    }
    if (payload['preferredNumbers']) {
      delete payload['preferredNumbers'];
    }
    if (this.paymentMethod == 2) {
      payload['paymentMethod'] = 'loyalty';
    }
	if(this.travelInsuranceAdded){
		payload['isAdditionalAddonSubscription'] = false;
		localStorage.setItem('travelInsuranceAddonPayload', JSON.stringify(payload));
	}
    this.addonToCart();
	let basketAddons = this.createBasketAddons();
   if(this.sku && this.sku?.type == 'passAddonSku'){
		const buyAddonRequest = {
			"accountNo":this.mobileNumber,
			"validate": false,
			"type": "ONE_TIME",
			"quantity": 1,
			"locale":this.lang,
			"basketAddons": basketAddons,
			"mode":'caramel',
      'gamingAddon': false,
      "addonId": this.sku.skuId
		};
		this.subscribeDisabled = false;
		this.SKUDS.addAddons(buyAddonRequest, link).subscribe((response: any) => {
			if(response && response.data && response.data.bogoSkus && response.data.bogoSkus?.length > 0){
				sessionStorage.setItem("BOGOs", JSON.stringify(response.data.bogoSkus));
				this.openBottomSheet(BogoOfferPopupComponent, null, 'verification-modal eand-partail-height-screen-bottom-70-mobile');
			}else {
				this.handleAddonBuySuccess(response);
			}
		},(e) => {
			this.handleAddonSubscriptionErrors(e);
		})
		return;
   }
    else if (this.sku && this.sku.productType == 'BRIDGE_ADDON') {
      if (this.selectedFregement == 0) {
        payload.forwardCountryCode = this.countrycode;
        payload.forwardCountryNumber = this.callForwardNumber.replace(
          this.countrycode,
          ''
        );

        let specialForwardCountryCodeObject = {
          fieldName: 'forward_country_code',
          fieldValue: payload.forwardCountryCode,
        };
        let specialForwardCountryNumberObject = {
          fieldName: 'forward_country_number',
          fieldValue: payload.forwardCountryNumber,
        };
        payload.specialInputs.push(specialForwardCountryCodeObject);
        payload.specialInputs.push(specialForwardCountryNumberObject);
      } else {
        let [hours, minutes] = this.reminderTime.split(":");
        if (hours == "12") {
          hours = "00";
        }

        if (this.reminderAmPm == "PM") {
          hours = parseInt(hours, 10) + 12;
        }

        let time = hours + ":" + minutes + ":00";
        let date = this.reminderDate.day + "/" + (this.reminderDate.month - 1) + "/" + this.reminderDate.year;

        this.reminderDateTime = date + " " + time;

        payload.reminder_date_time = this.reminderDateTime;
        let specialReminderDateTimeObject = {
          fieldName: 'reminder_date_time',
          fieldValue: payload.reminder_date_time,
        };
        payload.specialInputs.push(specialReminderDateTimeObject);
      }

      if (this.LoggedIn) {
        link = '/addAddOn';
        payload.skuid = this.sku.skuId;
        payload.accountNumber = this.accountId;
      }

      this.SKUDS.addAddons(payload, link).subscribe(
        (r: any) => {
          this.subscribeDisabled = false
          if (r) {
            if (r.success == true || r.success == 'true') {
              this.purchase(r.transactionNo, this.price);
              this.SS.addonBuySuccessfully.next({
                success: true,
                mobileNumber: this.mobileNumber,
                price: this.price,
                billType: this.isATPostpaid
                  ? 1
                  : this.paymentMethod && this.paymentMethod == 2
                    ? 2
                    : 3,
                data: r,
                addonType: this.sku.productType,
              });
              let catID = '';
              if(localStorage.getItem('CAT')){
                catID = localStorage.getItem('CAT');
              }
              this.GAS.onSubscribeSuccessAddon(
                'Purchase',
                'Addons',
                this.sku?.productType,
                this.sku?.displayName,
                this.sku?.brand,
                catID,
                this.sku?.id ? this.sku?.id : this.sku?.skuId ? this.sku?.skuId : '',
                this.sku?.validity,
                "WEB",
                this.sku?.listPrice,
                "AED",
                "1"
              );
              this.cdr.detectChanges();
            } else if (r.reason) {
              this.UTS.error(r.reason);
            } else {
              this.UTS.error(AppSettings.ERROR);
            }
          }
        },
        (e) => {
          this.GAS.onClickDetailsAddon('addons_subscription_fail',this.sku?.displayName,this.sku?.displayName,e?.error?.errorDescription,'GUEST','OTP', this.sku?.id);
          this.subscribeDisabled = false
          let eMessage = '';
          if((e?.error?.errorDescription.toUpperCase().search(AppSettings.ERROR_CRM_016) != -1) ||
              (e?.error?.message.toUpperCase().search(AppSettings.ERROR_CRM_016) != -1) || 
              (e?.error?.newErrorCode.toUpperCase().search(AppSettings.ERROR_CRM_016) != -1) 
          ){
            // eligible for free parental addon subscription
            this.openBottomSheet(SuccessComponent, {isFreeParentalEligible: true});
			      return;
          }
          if (this.UTS.getLocaleLanguage() == 'en') {
            if (
              e?.error?.errorDescription == AppSettings.ERROR_RTF_VAL_00080 ||
              e?.error?.message == AppSettings.ERROR_RTF_VAL_00080 || 
              e?.error?.newErrorCode == AppSettings.ERROR_RTF_VAL_00080 ||
              e?.error?.errorDescription == AppSettings.ERROR_VAL_00080 ||
              e?.error?.message == AppSettings.ERROR_VAL_00080 || 
              e?.error?.newErrorCode == AppSettings.ERROR_VAL_00080
            ) {
              this.translate.get('ERROR_RTF_VAL_00080').subscribe((message) => {
                eMessage = message;
              });
            }
            else if (
              e?.error?.errorDescription == AppSettings.ERROR_VAL_00015 ||
              e?.error?.errorDescription == AppSettings.ECARE_ERROR_VAL_00015
            ) {
              this.translate.get('ERROR_VAL_00015').subscribe((message) => {
                //   this.UTS.error(message);
                eMessage = message;
              });
            } else if (
              e?.error?.errorDescription == AppSettings.ERROR_VAL_00305
            ) {
              this.translate.get('ERROR_VAL_00305').subscribe((message) => {
                eMessage = message;
              });
            } else if (
              e?.error?.errorDescription == AppSettings.ERROR_VAL_00167
            ) {
              this.translate.get('ERROR_VAL_00167').subscribe((message) => {
                eMessage = message;
              });
            } else if (
              e?.error?.errorDescription == AppSettings.ERROR_VAL_00303
            ) {
              this.translate.get('ERROR_VAL_00303').subscribe((message) => {
                eMessage = message;
              });
            } else if (
              e?.error?.errorDescription == AppSettings.ERROR_CBCM_00002 ||
              e?.error?.errorDescription == AppSettings.ERROR_VAL_00180
            ) {
              this.translate.get('ERROR_CBCM_00002').subscribe((message) => {
                eMessage = message;
              });
            } else if (
              e?.error?.errorDescription == AppSettings.ERROR_VAL_00227
            ) {
              this.translate.get('ERROR_VAL_00227').subscribe((message) => {
                eMessage = message;
              });
            } else if (e?.error?.errorDescription == AppSettings.ERROR_IN_00002) {
              this.translate.get('ERROR_IN_00002').subscribe((message) => {
                eMessage = message;
              });
            } else if (
              e?.error?.errorDescription == AppSettings.ERROR_VAL_00011 ||
              e?.error?.message == AppSettings.ERROR_VAL_00011 ||
              e?.error?.message == AppSettings.ERROR_VAL_00002 ||
              e?.error?.errorDescription == AppSettings.ERROR_VAL_00002
            ) {
              this.translate.get('ERROR_VAL_00011').subscribe((message) => {
                eMessage = message;
              });
            }
            else if (
              (e?.error && e?.error?.errorDescription && e?.error?.errorDescription.includes(AppSettings.VAL_00011)) ||
              (e?.error && e?.error?.message && e?.error?.message.includes(AppSettings.VAL_00011)) ||
              (e?.error && e?.error?.errorDescription && e?.error?.errorDescription.includes(AppSettings.VAL_EAQTY)) ||
              (e?.error && e?.error?.message && e?.error?.message.includes(AppSettings.VAL_EAQTY)) ||
              (e?.error && e?.error?.errorDescription && e?.error?.errorDescription.includes(AppSettings.VAL_00061)) ||
              (e?.error && e?.error?.message && e?.error?.message.includes(AppSettings.VAL_00061)) ||
              (e?.error && e?.error?.errorDescription && e?.error?.errorDescription.includes(AppSettings.VAL_00133)) ||
              (e?.error && e?.error?.message && e?.error?.message.includes(AppSettings.VAL_00133)) ||
              (e?.error && e?.error?.errorDescription && e?.error?.errorDescription.includes(AppSettings.VAL_00013)) ||
              (e?.error && e?.error?.message && e?.error?.message.includes(AppSettings.VAL_00013))
            ) {
              this.translate.get('ERROR_VAL_00011').subscribe((message) => {
                eMessage = message;
              });
            } else if (e?.error?.errorDescription?.includes(AppSettings.COMS_00001)) {
              this.translate.get('COMS_00001').subscribe((message) => {
                eMessage = message;
              });
            }
            else if(e.error && e.error.errorDescription && !eMessage){
              const errorObj = this.UTS.searchValidationErrorCode(e.error.errorDescription);
              if(errorObj){
                eMessage = this.lang === 'ar' ?  this.UTS.convertUnicodeToArabic(errorObj?.errorTextAr): errorObj?.errorTextEn
              }else{
                if (e.error && e.error.newErrorCode && !eMessage) {
                  const errorObj = this.UTS.searchValidationErrorCode(e.error.newErrorCode);
                  if (errorObj) {
                    eMessage = this.lang === 'ar' ? this.UTS.convertUnicodeToArabic(errorObj?.errorTextAr) : errorObj?.errorTextEn
                  }
                }
              }
            } else {
              eMessage = e?.error?.errorDescription;
              //   this.UTS.error(e?.error?.errorDescription);
            }
          } else {
            if (
              e?.error?.errorDescription == AppSettings.ERROR_RTF_VAL_00080 ||
              e?.error?.message == AppSettings.ERROR_RTF_VAL_00080 || 
              e?.error?.newErrorCode == AppSettings.ERROR_RTF_VAL_00080 ||
              e?.error?.errorDescription == AppSettings.ERROR_VAL_00080 ||
              e?.error?.message == AppSettings.ERROR_VAL_00080 || 
              e?.error?.newErrorCode == AppSettings.ERROR_VAL_00080
            ) {
              this.translate.get('ERROR_RTF_VAL_00080').subscribe((message) => {
                eMessage = message;
              });
            }
            else if (
              e?.error?.errorDescription == AppSettings.ERROR_VAL_00015 ||
              e?.error?.errorDescription == AppSettings.ECARE_ERROR_VAL_00015
            ) {
              this.translate.get('ERROR_VAL_00015').subscribe((message) => {
                //   this.UTS.error(message);
                eMessage = message;
              });
            } else if (
              e?.error?.errorDescription == AppSettings.ERROR_VAL_00305
            ) {
              this.translate.get('ERROR_VAL_00305').subscribe((message) => {
                eMessage = message;
              });
            } else if (
              e?.error?.errorDescription == AppSettings.ERROR_VAL_00167
            ) {
              this.translate.get('ERROR_VAL_00167').subscribe((message) => {
                eMessage = message;
              });
            } else if (
              e?.error?.errorDescription == AppSettings.ERROR_VAL_00303
            ) {
              this.translate.get('ERROR_VAL_00303').subscribe((message) => {
                eMessage = message;
              });
            } else if (
              e?.error?.errorDescription == AppSettings.ERROR_VAL_00227
            ) {
              this.translate.get('ERROR_VAL_00227').subscribe((message) => {
                eMessage = message;
              });
            } else if (
              e?.error?.errorDescription == AppSettings.ERROR_CBCM_00002 ||
              e?.error?.errorDescription == AppSettings.ERROR_VAL_00180
            ) {
              this.translate.get('ERROR_CBCM_00002').subscribe((message) => {
                eMessage = message;
              });
            } else if (e?.error?.errorDescription == AppSettings.ERROR_IN_00002) {
              this.translate.get('ERROR_IN_00002').subscribe((message) => {
                eMessage = message;
              });
            } else if (
              e?.error?.errorDescription == AppSettings.ERROR_VAL_00011 ||
              e?.error?.message == AppSettings.ERROR_VAL_00011 ||
              e?.error?.message == AppSettings.ERROR_VAL_00002 ||
              e?.error?.errorDescription == AppSettings.ERROR_VAL_00002
            ) {
              this.translate.get('ERROR_VAL_00011').subscribe((message) => {
                eMessage = message;
              });
            }
            else if (
              (e?.error && e?.error?.errorDescription && e?.error?.errorDescription.includes(AppSettings.VAL_00011)) ||
              (e?.error && e?.error?.message && e?.error?.message.includes(AppSettings.VAL_00011)) ||
              (e?.error && e?.error?.errorDescription && e?.error?.errorDescription.includes(AppSettings.VAL_EAQTY)) ||
              (e?.error && e?.error?.message && e?.error?.message.includes(AppSettings.VAL_EAQTY)) ||
              (e?.error && e?.error?.errorDescription && e?.error?.errorDescription.includes(AppSettings.VAL_00061)) ||
              (e?.error && e?.error?.message && e?.error?.message.includes(AppSettings.VAL_00061)) ||
              (e?.error && e?.error?.errorDescription && e?.error?.errorDescription.includes(AppSettings.VAL_00133)) ||
              (e?.error && e?.error?.message && e?.error?.message.includes(AppSettings.VAL_00133)) ||
              (e?.error && e?.error?.errorDescription && e?.error?.errorDescription.includes(AppSettings.VAL_00013)) ||
              (e?.error && e?.error?.message && e?.error?.message.includes(AppSettings.VAL_00013))
            ) {
              this.translate.get('ERROR_VAL_00011').subscribe((message) => {
                eMessage = message;
              });
            } else if (e?.error?.errorDescription?.includes(AppSettings.COMS_00001)) {
              this.translate.get('COMS_00001').subscribe((message) => {
                eMessage = message;
              });
            } 
            else if(e.error && e.error.errorDescription && !eMessage){
                const errorObj = this.UTS.searchValidationErrorCode(e.error.errorDescription);
                if(errorObj){
                  eMessage = this.lang === 'ar' ?  this.UTS.convertUnicodeToArabic(errorObj?.errorTextAr): errorObj?.errorTextEn
                }else{
                  if (e.error && e.error.newErrorCode && !eMessage) {
                    const errorObj = this.UTS.searchValidationErrorCode(e.error.newErrorCode);
                    if (errorObj) {
                      eMessage = this.lang === 'ar' ? this.UTS.convertUnicodeToArabic(errorObj?.errorTextAr) : errorObj?.errorTextEn
                    }
                  }
                }
            }else {
              eMessage = e?.error?.errorDescriptionAr;
              //   this.UTS.error(e?.error?.errorDescriptionAr);
            }
          }
          this.SS.addonBuyError.next(eMessage);
          this.SS.addonBuySuccessfully.next({ success: false, data: e });
        }
      );
    } else {
      this.SKUDS.addAddons(payload, link).subscribe(
        (r: any) => {
          this.subscribeDisabled = false
          if (r) {
            if (r.success == true || r.success == 'true') {
              this.purchase(r.transactionNo, this.price);
              this.SS.addonBuySuccessfully.next({
                success: true,
                mobileNumber: this.mobileNumber,
                price: this.price,
                billType: this.isATPostpaid
                  ? 1
                  : this.paymentMethod && this.paymentMethod == 2
                    ? 2
                    : 3,
                data: r,
              });
			  if(r?.token){
				localStorage.setItem('travelInsuranceToken', r?.token);
			  }
        let catID = '';
        if(localStorage.getItem('CAT')){
          catID = localStorage.getItem('CAT');
        }
        this.GAS.onSubscribeSuccessAddon(
          'Purchase',
          'Addons',
          this.sku?.productType,
          this.sku?.displayName,
          this.sku?.brand,
          catID,
          this.sku?.id ? this.sku?.id : this.sku?.skuId ? this.sku?.skuId : '',
          this.sku?.validity,
          "WEB",
          this.sku?.listPrice,
          "AED",
          "1"
        );
              this.cdr.detectChanges();
            } else if (r.reason) {
              this.UTS.error(r.reason);
            } else {
              this.UTS.error(AppSettings.ERROR);
            }
          }
        },
        (e) => {
			this.handleAddonSubscriptionErrors(e);
        }
      );
    }
  }

  getPrice() {
    this.price = Number(
      this.sku.listPrice && this.parsePrice(this.sku.listPrice) > 0
        ? this.sku.listPrice
        : this.sku.recurringPrice &&
          this.parsePrice(this.sku.recurringPrice) > 0
          ? this.sku.recurringPrice
          : '0'
    ).toFixed(2);

    // this.price = Number(Number(this.sku.listPrice) * this.quantity).toFixed(2);
    this.cdr.detectChanges();
  }

  agreeToggle(e) {
    if (e.target.checked) {
      this.agreedOnterms = true;
    }
    else {
      this.agreedOnterms = false;
    }
    this.cdr.detectChanges();
  }

  agreeToggleLastExist(e) {
    this.isExpended = !this.isExpended;
    this.cdr.detectChanges();
  }

  onTermsClick()
  {
    this.isExpended = !this.isExpended;
    this.onTermsAndConditions();
  }
  onTermsAndConditions()
  {
    let modal={
      event:'b2b_fire_event',
      eventCategory:'roaming',
      eventAction:'termsandConditions',
      eventLabel:'Accept or Deny',
      typeOfRoaming:this.sku?.displayName,
      user_env:this.UTS.getENV()
    }
    this.GAS.onTermsAndConditions_Roaming(modal);
  }

  getAccountType() {
    this.PS.getAccountType(this.mobileNumber).subscribe(
      (res: any) => {
        if (res && res.accountType) {
          this.accountId = res.accountId;
          if (res.accountType.toLowerCase() == 'postpaid') {
            this.isATPostpaid = true;
          } else {
            this.isATPostpaid = false;
          }
        } else {
          this.isATPostpaid = false;
        }
        this.getQuickPay();
        this.checkControlline();
     
      },
      (e) => {
        this.UTS.log(e);
        this.checkControlline();
      }
    );
  }
  // getManageExtra(accountId)
  // {
   
  //   this.AS.getManageExtra(accountId).subscribe((x:any)=>{
  //     if(x?.accountAddons !=null)
  //     {
  //         if(x.accountAddons.length>0)
  //         {
  //            x.accountAddons.forEach(element => {

  //             let code = element?.ECMAddonDetail?.productCode?.split('_');

  //              this.subscribedAddonList.push(code[0]);
  //            });
  //            localStorage.setItem('subscribedList',  JSON.stringify(this.subscribedAddonList));
  //         }
  //     }
  //   });
    
  // }

  getAccountTypeLogin() {
    if (this.currentAccount && this.currentAccount.accountType == 'POSTPAID') {
      this.isATPostpaid = true;
    } else {
      this.isATPostpaid = false;
    }
    this.checkControlline();
  }

  checkControlline() {
    this.aRoute.queryParams.subscribe((q) => {
      if (q && q.subCategory) {
        const subCategory = q.subCategory;
        if (subCategory == AppSettings.CONTROL_LINE) {
          this.isControlLine = true;
          this.isATPostpaid = false;
        }
      }
      setTimeout(() => {
        if (this.sku.displayName.includes('Control Line')) {
          this.isControlLine = true;
          this.isATPostpaid = false;
        }
      }, 500);
    });
  }
  getCountries() {
    this.PS.getCountries(this.sku.skuId).subscribe(
      (res: any) => {
        if (res) {
          this.countries = res.countries;
          this.loadFlags();
        }
      },
      (e) => this.UTS.log(e)
    );
  }

  segmentChanged(val) {
    this.selectedFregement = val
  }

  chooseCountry(e) {
    this.countrycode = e.code;
  }

  loadFlags() {
    setTimeout(() => {
      let radios = document.getElementsByClassName('alert-radio-label');
      for (let index = 1; index < radios.length; index++) {
        let element = radios[index];
        element.innerHTML = element.innerHTML.concat(
          '<img class="country-image" style="width: 30px;height:16px;" src="' +
          this.countries[index - 1].flag +
          '" />'
        );
      }
    }, 2000);
  }

  addPaymentMethod(e) {
    this.paymentMethod = e.target.value;
  }

  addonToCart() {
    if (
      // this.categoryDetail &&
      // this.addon &&
      // (this.categoryDetail.categoryTitle ||
      //   this.categoryDetail.currentCategory) &&
      this.sku &&
      this.sku.displayName &&
      (this.sku.id || this.sku.skuId) &&
      this.sku.listPrice
    ) {
      const data :any = JSON.parse(localStorage.getItem('ProductCategory')) ;

      this.GAS.addToCart(
        // this.addon,
        // this.categoryDetail.categoryTitle
        //   ? this.categoryDetail.categoryTitle
        //   : this.categoryDetail.currentCategory,
        data?.cat,
        data?.product,
        this.sku.displayName,
        this.sku.id ? this.sku.id : this.sku.skuId ? this.sku.skuId : '',
        this.sku.listPrice,
        this.quantity,
        this.sku.brand
      );
    }
  }
  private purchase(TID, R) {
    if (
      this.categoryDetail &&
      this.addon &&
      (this.categoryDetail.categoryTitle ||
        this.categoryDetail.currentCategory) &&
      this.sku &&
      this.sku.displayName &&
      (this.sku.id || this.sku.skuId) &&
      this.sku.listPrice
    ) {
      this.GAS.purchase(
        this.addon,
        this.categoryDetail.categoryTitle
          ? this.categoryDetail.categoryTitle
          : this.categoryDetail.currentCategory,
        this.sku.displayName,
        this.sku.id ? this.sku.id : this.sku.skuId ? this.sku.skuId : '',
        this.sku.listPrice,
        this.quantity,
        this.sku.brand,
        TID ? TID : '',
        R
      );
    }
  }

  parsePrice(v) {
    if (Number(v)) {
      return Number(v);
    }
    return v;
  }

  getSmilePoint() {
    if (this.userInfo) {
      if (this.currentAccount && this.currentAccount.accountId) {
        this.accountId = this.currentAccount.accountId;
        this.PS.getAccountSummary(this.accountId).subscribe((resp: any) => {
          if (resp && resp.userAccount) {
            this.smilePointsOfUser = Number(resp.userAccount.accountSmilesPoints);
            if (resp.userAccount.currentBalance && Number(resp.userAccount.currentBalance) > 0) {
              this.currentBalance = Number(resp.userAccount.currentBalance);
            }
            else {
              this.currentBalance = 0;
            }
            this.showSmilesPoints = true;
            if (
              this.sku &&
              this.sku.smilesPoints &&
              (this.smilePointsOfUser) > (this.sku.smilesPoints.replace(/,/g , ''))
            ) {
              this.disabledSmilePoints = false;
            }
            //  }
            if (resp.userAccount.accountSmilesPoints) {
              this.isprimary = resp.userAccount.primary;
            }
          }
          this.getQuickPay();
        }, e => {
          this.getQuickPay();
        });
      }
    }
  }

  getQuickPay() {
    this.ACCS.getQuickPay(this.mobileNumber).subscribe((res: any) => {
      if (this.isATPostpaid == false) {
        if (res && res?.prepaidBalance) {
          this.currentBalance = Number(res?.prepaidBalance) > 0 ? Number(res?.prepaidBalance) : 0;
        }
      }
    }, err => {
      // this.currentBalance = 100;
    });
  }

  prepaidBalanceLessThanAddonCost() {
    const check = (this.sku?.listPrice && (this.currentBalance < this.parsePrice(this.sku?.listPrice))) ? true : (this.sku?.recurringPrice && (this.currentBalance < this.parsePrice(this.sku?.recurringPrice))) ? true : false;
    return check
  }


  getAccount() {
    let userImages = null;
    this.ACCS.getUserInfo().subscribe(
      (res) => {
        if (res && res?.imageBase64String) {
          userImages = res.imageBase64String
        }
        this.isUserLoggedIn = true;
        this.LoggedIn = true;
        this.cdr.detectChanges();
      },
      (e) => {
        this.isUserLoggedIn = false;
        this.LoggedIn = false;
        this.userInfo = null;
      }
    );
  }


  addAddonLoggedIn() {
    this.UTS.clearError();
    let link = '/addAddonsLoggedIn';
    if (this.paymentMethod == 2) {
      if (parseInt(this.price) > this.smilePointsOfUser) {
        this.UTS.error('Error! Not Enough Smile Points');
        return;
      }
    }
    let specialInput = []; //this.sku.specialInput ? this.sku.specialInput :
    localStorage.setItem('mobileNumber', this.mobileNumber);
    const payload = {
      accountNo: this.mobileNumber,
      accountNumber: null,
      addonId: this.sku.skuId,
      skuid: null,
      validate: false,
      type: this.autoRenew == true ? 'AUTO_RENEWAL' : 'ONE_TIME',
      quantity: this.quantity,
      specialInputs: specialInput,
      locale: this.UTS.getLocaleLanguage().toString().toLocaleUpperCase(),
      forwardCountryCode: null,
      forwardCountryNumber: null,
      reminder_date_time: null,
    };
    if (payload['preferredNumbers']) {
      delete payload['preferredNumbers'];
    }
    if (this.paymentMethod == 2) {
      payload['paymentMethod'] = 'loyalty';
    }
    if(this.isAddonRecommended(this.sku?.skuId)){
      payload['isRecommended'] = true;
    }
    this.addonToCart();
    payload.accountNo = this.accountId;
    payload['preferredNumbers'] = this.mobileNumber;
    link = '/addAddonsLoggedIn';
    const ocrResponse = JSON.parse(localStorage.getItem('OCR_RESPONSE'));
    if(this.sku && this.sku?.productType  && this.sku?.productType  == AppSettings.KIDS_ADDONS && ocrResponse && ocrResponse?.documentId){
      payload['kidEIDNumber'] = ocrResponse?.documentId;
    }
	// DBB-5723 - BOGO addons
	let basketAddons = this.createBasketAddons();
	if(this.sku && this.sku?.type == 'passAddonSku'){
		const buyAddonRequest = {
			"accountNo": this.mobileNumber,
			"validate": false,
			"type": "ONE_TIME",
			"quantity": 1,
			"locale":this.lang,
			"basketAddons": basketAddons,
			"mode":'caramel',
      'gamingAddon': false,
      "addonId": this.sku.skuId
		};
		this.subscribeDisabled = false;
		this.SKUDS.addAddons(buyAddonRequest, link).subscribe((response: any) => {
			if(response && response.data && response.data.bogoSkus && response.data.bogoSkus?.length > 0){
				sessionStorage.setItem("BOGOs", JSON.stringify(response.data.bogoSkus));
				this.openBottomSheet(BogoOfferPopupComponent, null, 'verification-modal eand-partail-height-screen-bottom-70-mobile');
			}else {
				this.handleAddonBuySuccess(response);
			}
		},(e) => {
			this.handleAddonSubscriptionErrors(e);
		})
		return;
    // DBB-5723 - BOGO addons
	   }
    else if (this.sku && this.sku.productType == 'BRIDGE_ADDON') {
      if (this.selectedFregement == 0) {
        payload.forwardCountryCode = this.countrycode;
        payload.forwardCountryNumber = this.callForwardNumber.replace(
          this.countrycode,
          ''
        );

        let specialForwardCountryCodeObject = {
          fieldName: 'forward_country_code',
          fieldValue: payload.forwardCountryCode,
        };
        let specialForwardCountryNumberObject = {
          fieldName: 'forward_country_number',
          fieldValue: payload.forwardCountryNumber,
        };
        payload.specialInputs.push(specialForwardCountryCodeObject);
        payload.specialInputs.push(specialForwardCountryNumberObject);
      } else {
        let [hours, minutes] = this.reminderTime.split(":");
        if (hours == "12") {
          hours = "00";
        }

        if (this.reminderAmPm == "PM") {
          hours = parseInt(hours, 10) + 12;
        }

        let time = hours + ":" + minutes + ":00";
        let date = this.reminderDate.day + "/" + (this.reminderDate.month - 1) + "/" + this.reminderDate.year;

        this.reminderDateTime = date + " " + time;

        payload.reminder_date_time = this.reminderDateTime;
        let specialReminderDateTimeObject = {
          fieldName: 'reminder_date_time',
          fieldValue: payload.reminder_date_time,
        };
        payload.specialInputs.push(specialReminderDateTimeObject);
      }

      if (this.LoggedIn) {
        link = '/addAddOn';
        payload.skuid = this.sku.skuId;
        payload.accountNumber = this.accountId;
      }

      this.SKUDS.addAddons(payload, link).subscribe(
        (r: any) => {
          this.subscribeDisabled = false
          if (r) {
            if (r.success == true || r.success == 'true') {
              this.purchase(r.transactionNo, this.price);
              this.SS.addonBuySuccessfully.next({
                success: true,
                mobileNumber: this.mobileNumber,
                price: this.price,
                billType: this.isATPostpaid
                  ? 1
                  : this.paymentMethod && this.paymentMethod == 2
                    ? 2
                    : 3,
                data: r,
                addonType: this.sku.productType,
              });
              let catID = '';
              if(localStorage.getItem('CAT')){
                catID = localStorage.getItem('CAT');
              }
              this.GAS.onSubscribeSuccessAddon(
                'Purchase',
                'Addons',
                this.sku?.productType,
                this.sku?.displayName,
                this.sku?.brand,
                catID,
                this.sku?.id ? this.sku?.id : this.sku?.skuId ? this.sku?.skuId : '',
                this.sku?.validity,
                "WEB",
                this.sku?.listPrice,
                "AED",
                "1"
              );
              this.cdr.detectChanges();
            } else if (r.reason) {
              this.UTS.error(r.reason);
            } else {
              this.UTS.error(AppSettings.ERROR);
            }
          }
        },
        (e) => {
          this.GAS.onClickDetailsAddon('addons_subscription_fail',this.sku?.displayName,this.sku?.displayName,e?.error?.errorDescription,'logged_in','OTP', this.sku?.id);
          this.subscribeDisabled = false
          let eMessage = '';
          if( e?.error?.errorDescription.toUpperCase().search(AppSettings.ERROR_CRM_016) != -1){
            // eligible for free parental addon subscription
            this.openBottomSheet(SuccessComponent, {isFreeParentalEligible: true});
            return;
          }
          if (this.UTS.getLocaleLanguage() == 'en') {
            if (
              e?.error?.errorDescription == AppSettings.ERROR_RTF_VAL_00080 ||
              e?.error?.message == AppSettings.ERROR_RTF_VAL_00080 || 
              e?.error?.newErrorCode == AppSettings.ERROR_RTF_VAL_00080 ||
              e?.error?.errorDescription == AppSettings.ERROR_VAL_00080 ||
              e?.error?.message == AppSettings.ERROR_VAL_00080 || 
              e?.error?.newErrorCode == AppSettings.ERROR_VAL_00080
            ) {
              this.translate.get('ERROR_RTF_VAL_00080').subscribe((message) => {
                eMessage = message;
              });
            }
            else if (
              e?.error?.errorDescription == AppSettings.ERROR_VAL_00015 ||
              e?.error?.errorDescription == AppSettings.ECARE_ERROR_VAL_00015
            ) {
              this.translate.get('ERROR_VAL_00015').subscribe((message) => {
                //   this.UTS.error(message);
                eMessage = message;
              });
            } else if (
              e?.error?.errorDescription == AppSettings.ERROR_VAL_00305
            ) {
              this.translate.get('ERROR_VAL_00305').subscribe((message) => {
                eMessage = message;
              });
            } else if (
              e?.error?.errorDescription == AppSettings.ERROR_VAL_00167
            ) {
              this.translate.get('ERROR_VAL_00167').subscribe((message) => {
                eMessage = message;
              });
            } else if (
              e?.error?.errorDescription == AppSettings.ERROR_VAL_00303
            ) {
              this.translate.get('ERROR_VAL_00303').subscribe((message) => {
                eMessage = message;
              });
            } else if (
              e?.error?.errorDescription == AppSettings.ERROR_CBCM_00002 ||
              e?.error?.errorDescription == AppSettings.ERROR_VAL_00180
            ) {
              this.translate.get('ERROR_CBCM_00002').subscribe((message) => {
                eMessage = message;
              });
            } else if (
              e?.error?.errorDescription == AppSettings.ERROR_VAL_00227
            ) {
              this.translate.get('ERROR_VAL_00227').subscribe((message) => {
                eMessage = message;
              });
            } else if (e?.error?.errorDescription == AppSettings.ERROR_IN_00002) {
              this.translate.get('ERROR_IN_00002').subscribe((message) => {
                eMessage = message;
              });
            } else if (
              e?.error?.errorDescription == AppSettings.ERROR_VAL_00011 ||
              e?.error?.message == AppSettings.ERROR_VAL_00011 ||
              e?.error?.message == AppSettings.ERROR_VAL_00002 ||
              e?.error?.errorDescription == AppSettings.ERROR_VAL_00002
            ) {
              this.translate.get('ERROR_VAL_00011').subscribe((message) => {
                eMessage = message;
              });
            }
            else if (
              (e?.error && e?.error?.errorDescription && e?.error?.errorDescription?.includes(AppSettings.VAL_00011)) ||
              (e?.error && e?.error?.message && e?.error?.message?.includes(AppSettings.VAL_00011)) ||
              (e?.error && e?.error?.errorDescription && e?.error?.errorDescription?.includes(AppSettings.VAL_EAQTY)) ||
              (e?.error && e?.error?.message && e?.error?.message.includes(AppSettings.VAL_EAQTY)) ||
              (e?.error && e?.error?.errorDescription && e?.error?.errorDescription?.includes(AppSettings.VAL_00061)) ||
              (e?.error && e?.error?.message && e?.error?.message?.includes(AppSettings.VAL_00061)) ||
              (e?.error && e?.error?.errorDescription && e?.error?.errorDescription?.includes(AppSettings.VAL_00133)) ||
              (e?.error && e?.error?.message && e?.error?.message?.includes(AppSettings.VAL_00133)) ||
              (e?.error && e?.error?.errorDescription && e?.error?.errorDescription?.includes(AppSettings.VAL_00013)) ||
              (e?.error && e?.error?.message && e?.error?.message?.includes(AppSettings.VAL_00013))
            ) {
              this.translate.get('ERROR_VAL_00011').subscribe((message) => {
                eMessage = message;
              });
            } else if (e?.error?.errorDescription?.includes(AppSettings.ERROR_VAL_00019)) {
              this.translate.get('ERROR_VAL_00019').subscribe((message) => {
                eMessage = message;
              });
            } else if (e?.error?.errorDescription?.includes(AppSettings.COMS_00001)) {
              this.translate.get('COMS_00001').subscribe((message) => {
                eMessage = message;
              });
            }
            else if(e.error && e.error.errorDescription && !eMessage){
                const errorObj = this.UTS.searchValidationErrorCode(e.error.errorDescription);
                if(errorObj){
                  eMessage = this.lang === 'ar' ?  this.UTS.convertUnicodeToArabic(errorObj?.errorTextAr): errorObj?.errorTextEn
                }else{
                  if (e.error && e.error.newErrorCode && !eMessage) {
                    const errorObj = this.UTS.searchValidationErrorCode(e.error.newErrorCode);
                    if (errorObj) {
                      eMessage = this.lang === 'ar' ? this.UTS.convertUnicodeToArabic(errorObj?.errorTextAr) : errorObj?.errorTextEn
                    }
                  }
                }
            }
            else {
              eMessage = e?.error?.errorDescription;
              //   this.UTS.error(e?.error?.errorDescription);
            }
          } else {
            if (
              e?.error?.errorDescription == AppSettings.ERROR_RTF_VAL_00080 ||
              e?.error?.message == AppSettings.ERROR_RTF_VAL_00080 || 
              e?.error?.newErrorCode == AppSettings.ERROR_RTF_VAL_00080 ||
              e?.error?.errorDescription == AppSettings.ERROR_VAL_00080 ||
              e?.error?.message == AppSettings.ERROR_VAL_00080 || 
              e?.error?.newErrorCode == AppSettings.ERROR_VAL_00080
            ) {
              this.translate.get('ERROR_RTF_VAL_00080').subscribe((message) => {
                eMessage = message;
              });
            }
            else if (
              e?.error?.errorDescription == AppSettings.ERROR_VAL_00015 ||
              e?.error?.errorDescription == AppSettings.ECARE_ERROR_VAL_00015
            ) {
              this.translate.get('ERROR_VAL_00015').subscribe((message) => {
                //   this.UTS.error(message);
                eMessage = message;
              });
            } else if (
              e?.error?.errorDescription == AppSettings.ERROR_VAL_00305
            ) {
              this.translate.get('ERROR_VAL_00305').subscribe((message) => {
                eMessage = message;
              });
            } else if (
              e?.error?.errorDescription == AppSettings.ERROR_VAL_00167
            ) {
              this.translate.get('ERROR_VAL_00167').subscribe((message) => {
                eMessage = message;
              });
            } else if (
              e?.error?.errorDescription == AppSettings.ERROR_VAL_00303
            ) {
              this.translate.get('ERROR_VAL_00303').subscribe((message) => {
                eMessage = message;
              });
            } else if (
              e?.error?.errorDescription == AppSettings.ERROR_VAL_00227
            ) {
              this.translate.get('ERROR_VAL_00227').subscribe((message) => {
                eMessage = message;
              });
            } else if (
              e?.error?.errorDescription == AppSettings.ERROR_CBCM_00002 ||
              e?.error?.errorDescription == AppSettings.ERROR_VAL_00180
            ) {
              this.translate.get('ERROR_CBCM_00002').subscribe((message) => {
                eMessage = message;
              });
            } else if (e?.error?.errorDescription == AppSettings.ERROR_IN_00002) {
              this.translate.get('ERROR_IN_00002').subscribe((message) => {
                eMessage = message;
              });
            } else if (
              e?.error?.errorDescription == AppSettings.ERROR_VAL_00011 ||
              e?.error?.message == AppSettings.ERROR_VAL_00011 ||
              e?.error?.message == AppSettings.ERROR_VAL_00002 ||
              e?.error?.errorDescription == AppSettings.ERROR_VAL_00002
            ) {
              this.translate.get('ERROR_VAL_00011').subscribe((message) => {
                eMessage = message;
              });
            }
            else if (
              (e?.error && e?.error?.errorDescription && e?.error?.errorDescription?.includes(AppSettings.VAL_00011)) ||
              (e?.error && e?.error?.message && e?.error?.message?.includes(AppSettings.VAL_00011)) ||
              (e?.error && e?.error?.errorDescription && e?.error?.errorDescription?.includes(AppSettings.VAL_EAQTY)) ||
              (e?.error && e?.error?.message && e?.error?.message?.includes(AppSettings.VAL_EAQTY)) ||
              (e?.error && e?.error?.errorDescription && e?.error?.errorDescription?.includes(AppSettings.VAL_00061)) ||
              (e?.error && e?.error?.message && e?.error?.message?.includes(AppSettings.VAL_00061)) ||
              (e?.error && e?.error?.errorDescription && e?.error?.errorDescription?.includes(AppSettings.VAL_00133)) ||
              (e?.error && e?.error?.message && e?.error?.message?.includes(AppSettings.VAL_00133)) ||
              (e?.error && e?.error?.errorDescription && e?.error?.errorDescription?.includes(AppSettings.VAL_00013)) ||
              (e?.error && e?.error?.message && e?.error?.message?.includes(AppSettings.VAL_00013))
            ) {
              this.translate.get('ERROR_VAL_00011').subscribe((message) => {
                eMessage = message;
              });
            } else if (e?.error?.errorDescription.includes(AppSettings.ERROR_VAL_00019)) {
              this.translate.get('ERROR_VAL_00019').subscribe((message) => {
                eMessage = message;
              });
            } else if (e?.error?.errorDescription?.includes(AppSettings.COMS_00001)) {
              this.translate.get('COMS_00001').subscribe((message) => {
                eMessage = message;
              });
            } else if(e.error && e.error.errorDescription && !eMessage){
                const errorObj = this.UTS.searchValidationErrorCode(e.error.errorDescription);
                if(errorObj){
                  eMessage = this.lang === 'ar' ?  this.UTS.convertUnicodeToArabic(errorObj?.errorTextAr): errorObj?.errorTextEn
                }else{
                  if (e.error && e.error.newErrorCode && !eMessage) {
                    const errorObj = this.UTS.searchValidationErrorCode(e.error.newErrorCode);
                    if (errorObj) {
                      eMessage = this.lang === 'ar' ? this.UTS.convertUnicodeToArabic(errorObj?.errorTextAr) : errorObj?.errorTextEn
                    }
                  }
                }
            }
            else {
              eMessage = e?.error?.errorDescriptionAr;
              //   this.UTS.error(e?.error?.errorDescriptionAr);
            }
          }
          this.SS.addonBuyError.next(eMessage);
          this.SS.addonBuySuccessfully.next({ success: false, data: e });
        }
      );
    } else {
      //DBB-5104
      if(this.travelInsuranceAdded){
        localStorage.setItem('travelInsuranceAddonPayload', JSON.stringify(payload));
      }
      //DBB-5104 end
      this.SKUDS.addAddons(payload, link).subscribe(
        (r: any) => {
          this.subscribeDisabled = false
          if (r) {
            if (r.success == true || r.success == 'true') {
              this.purchase(r.transactionNo, this.price);
              this.SS.addonBuySuccessfully.next({
                success: true,
                mobileNumber: this.mobileNumber,
                price: this.price,
                billType: this.isATPostpaid
                  ? 1
                  : this.paymentMethod && this.paymentMethod == 2
                    ? 2
                    : 3,
                data: r,
              });
              let catID = '';
              if(localStorage.getItem('CAT')){
                catID = localStorage.getItem('CAT');
              }
              this.GAS.onSubscribeSuccessAddon(
                'Purchase',
                'Addons',
                this.sku?.productType,
                this.sku?.displayName,
                this.sku?.brand,
                catID,
                this.sku?.id ? this.sku?.id : this.sku?.skuId ? this.sku?.skuId : '',
                this.sku?.validity,
                "WEB",
                this.sku?.listPrice,
                "AED",
                "1"
              );
              this.cdr.detectChanges();
            } else if (r.reason) {
              this.UTS.error(r.reason);
            } else {
              this.UTS.error(AppSettings.ERROR);
            }
          }
        },
        (e) => {
          this.GAS.onClickDetailsAddon('addons_subscription_fail',this.sku?.displayName,this.sku?.displayName,e?.error?.errorDescription,'logged_in','OTP', this.sku?.id);
          if( e?.error?.errorDescription.toUpperCase().search(AppSettings.ERROR_CRM_016)  != -1){
            // eligible for free parental addon subscription
            this.openBottomSheet(SuccessComponent, {isFreeParentalEligible: true});
            return;
          }
          this.subscribeDisabled = false
          let eMessage = '';
          if (this.UTS.getLocaleLanguage() == 'en') {
             if (
              e?.error?.errorDescription == AppSettings.ERROR_RTF_VAL_00080 ||
              e?.error?.message == AppSettings.ERROR_RTF_VAL_00080 || 
              e?.error?.newErrorCode == AppSettings.ERROR_RTF_VAL_00080 ||
              e?.error?.errorDescription == AppSettings.ERROR_VAL_00080 ||
              e?.error?.message == AppSettings.ERROR_VAL_00080 || 
              e?.error?.newErrorCode == AppSettings.ERROR_VAL_00080
            ) {
              this.translate.get('ERROR_RTF_VAL_00080').subscribe((message) => {
                eMessage = message;
              });
            }
            else if (
              e?.error?.errorDescription == AppSettings.ERROR_RTF_VAL_00015 ||
              e?.error?.errorDescription == AppSettings.ERROR_VAL_00015
            ) {
              this.translate.get('ERROR_VAL_00015').subscribe((message) => {
                //   this.UTS.error(message);
                eMessage = message;
              });
            }
            else if (
              e?.error?.errorDescription == AppSettings.ERROR_VAL_00011 ||
              e?.error?.message == AppSettings.ERROR_VAL_00011 ||
              e?.error?.message == AppSettings.ERROR_VAL_00002 ||
              e?.error?.errorDescription == AppSettings.ERROR_VAL_00002
            ) {
              this.translate.get('ERROR_VAL_00011').subscribe((message) => {
                eMessage = message;
              });
            } else if (
              (e?.error && e?.error?.errorDescription && e?.error?.errorDescription?.includes(AppSettings.VAL_00011)) ||
              (e?.error && e?.error?.message && e?.error?.message?.includes(AppSettings.VAL_00011)) ||
              (e?.error && e?.error?.errorDescription && e?.error?.errorDescription?.includes(AppSettings.VAL_EAQTY)) ||
              (e?.error && e?.error?.message && e?.error?.message?.includes(AppSettings.VAL_EAQTY)) ||
              (e?.error && e?.error?.errorDescription && e?.error?.errorDescription?.includes(AppSettings.VAL_00061)) ||
              (e?.error && e?.error?.message && e?.error?.message?.includes(AppSettings.VAL_00061)) ||
              (e?.error && e?.error?.errorDescription && e?.error?.errorDescription?.includes(AppSettings.VAL_00133)) ||
              (e?.error && e?.error?.message && e?.error?.message?.includes(AppSettings.VAL_00133)) ||
              (e?.error && e?.error?.errorDescription && e?.error?.errorDescription?.includes(AppSettings.VAL_00013)) ||
              (e?.error && e?.error?.message && e?.error?.message?.includes(AppSettings.VAL_00013))
            ) {
              this.translate.get('ERROR_VAL_00011').subscribe((message) => {
                eMessage = message;
              });
            } else if (e?.error?.errorDescription?.includes(AppSettings.ERROR_VAL_00019)) {
              this.translate.get('ERROR_VAL_00019').subscribe((message) => {
                eMessage = message;
              });
            }  else if (e?.error?.errorDescription?.includes(AppSettings.COMS_00001)) {
              this.translate.get('COMS_00001').subscribe((message) => {
                eMessage = message;
              });
            }
            else if(e.error && e.error.errorDescription && !eMessage){
                const errorObj = this.UTS.searchValidationErrorCode(e.error.errorDescription);
                if(errorObj){
                  eMessage = this.lang === 'ar' ?  this.UTS.convertUnicodeToArabic(errorObj?.errorTextAr): errorObj?.errorTextEn
                }else{
                  if (e.error && e.error.newErrorCode && !eMessage) {
                    const errorObj = this.UTS.searchValidationErrorCode(e.error.newErrorCode);
                    if (errorObj) {
                      eMessage = this.lang === 'ar' ? this.UTS.convertUnicodeToArabic(errorObj?.errorTextAr) : errorObj?.errorTextEn
                    }
                  }
                }
            } else {
              eMessage = e?.error?.errorDescription;
              //   this.UTS.error(e?.error?.errorDescription);
            }
          } else {
            if (
              e?.error?.errorDescription == AppSettings.ERROR_RTF_VAL_00080 ||
              e?.error?.message == AppSettings.ERROR_RTF_VAL_00080 || 
              e?.error?.newErrorCode == AppSettings.ERROR_RTF_VAL_00080 ||
              e?.error?.errorDescription == AppSettings.ERROR_VAL_00080 ||
              e?.error?.message == AppSettings.ERROR_VAL_00080 || 
              e?.error?.newErrorCode == AppSettings.ERROR_VAL_00080
            ) {
              this.translate.get('ERROR_RTF_VAL_00080').subscribe((message) => {
                eMessage = message;
              });
            }
            else if (e?.error?.errorDescription == AppSettings.ERROR_VAL_00015) {
              this.translate.get('ERROR_VAL_00015').subscribe((message) => {
                //  this.UTS.error(message);
                eMessage = message;
              });
            }
            else if (
              e?.error?.errorDescription == AppSettings.ERROR_VAL_00011 ||
              e?.error?.message == AppSettings.ERROR_VAL_00011 ||
              e?.error?.message == AppSettings.ERROR_VAL_00002 ||
              e?.error?.errorDescription == AppSettings.ERROR_VAL_00002
            ) {
              this.translate.get('ERROR_VAL_00011').subscribe((message) => {
                eMessage = message;
              });
            }
            else if (
              (e?.error && e?.error?.errorDescription && e?.error?.errorDescription?.includes(AppSettings.VAL_00011)) ||
              (e?.error && e?.error?.message && e?.error?.message?.includes(AppSettings.VAL_00011)) ||
              (e?.error && e?.error?.errorDescription && e?.error?.errorDescription?.includes(AppSettings.VAL_EAQTY)) ||
              (e?.error && e?.error?.message && e?.error?.message?.includes(AppSettings.VAL_EAQTY)) ||
              (e?.error && e?.error?.errorDescription && e?.error?.errorDescription?.includes(AppSettings.VAL_00061)) ||
              (e?.error && e?.error?.message && e?.error?.message?.includes(AppSettings.VAL_00061)) ||
              (e?.error && e?.error?.errorDescription && e?.error?.errorDescription?.includes(AppSettings.VAL_00133)) ||
              (e?.error && e?.error?.message && e?.error?.message?.includes(AppSettings.VAL_00133)) ||
              (e?.error && e?.error?.errorDescription && e?.error?.errorDescription?.includes(AppSettings.VAL_00013)) ||
              (e?.error && e?.error?.message && e?.error?.message?.includes(AppSettings.VAL_00013))
            ) {
              this.translate.get('ERROR_VAL_00011').subscribe((message) => {
                eMessage = message;
              });
            } else if (e?.error?.errorDescription?.includes(AppSettings.ERROR_VAL_00019)) {
              this.translate.get('ERROR_VAL_00019').subscribe((message) => {
                eMessage = message;
              });
            } else if (e?.error?.errorDescription?.includes(AppSettings.COMS_00001)) {
              this.translate.get('COMS_00001').subscribe((message) => {
                eMessage = message;
              });
            }
            else if(e.error && e.error.errorDescription && !eMessage){
                const errorObj = this.UTS.searchValidationErrorCode(e.error.errorDescription);
                if(errorObj){
                  eMessage = this.lang === 'ar' ?  this.UTS.convertUnicodeToArabic(errorObj?.errorTextAr): errorObj?.errorTextEn
                }else{
                  if (e.error && e.error.newErrorCode && !eMessage) {
                    const errorObj = this.UTS.searchValidationErrorCode(e.error.newErrorCode);
                    if (errorObj) {
                      eMessage = this.lang === 'ar' ? this.UTS.convertUnicodeToArabic(errorObj?.errorTextAr) : errorObj?.errorTextEn
                    }
                  }
                }
            } else {
              eMessage = e?.error?.errorDescriptionAr;
              //   this.UTS.error(e?.error?.errorDescriptionAr);
            }
          }
          this.SS.addonBuyError.next(eMessage);
          this.SS.addonBuySuccessfully.next({ success: false, data: e });
        }
      );
    }
  }

  openDetailPage(sku: any) {
    this.SKUDS.set(sku);
    this.SDS.setAddon(this.addon);
    this.SS.resetVerification.next(true)
    setTimeout(() => {
      this.subscribe(sku);
    }, 500);
  }

  private subscribe(sku: any) {
    this.SS.skuDetails.next(sku);
    this.openBottomSheet(VerificationComponent, { type: this.addon });
  }

  async openBottomSheet(component: any, data,classes = 'verification-modal modal-fullscreen' ) {
    const modal = await this.modalController.create({
      component: component,
      showBackdrop: true,
      componentProps: { data: data },
      // mode: "ios",
      cssClass: classes,
    });
    return await modal.present();
  }

  async openLearnMoreBottomSheet(flag: String) {
    let URL = '';
    if(flag == 'learnMore'){
      URL = this.isArabic ? this.skuAddonDetails?.skus[0]?.learnMoreAr : this.skuAddonDetails?.skus[0]?.learnMoreEn;
    }
    else if(flag == 'termsCondition'){
      if (!this.skuAddonDetails) {
        let sku = localStorage.getItem("skuAddonDetails");
        if (sku) this.skuAddonDetails = JSON.parse(sku);
      }
      URL = this.isArabic ? this.skuAddonDetails?.skus[0]?.tAndcAcceptanceAr : this.skuAddonDetails?.skus[0]?.tAndcAcceptanceEn;

    }
    let payload = {
      URL, flag
    };
    const modal = await this.modalController.create({
      component: LearnMoreTravelInsuranceComponent,
      showBackdrop: true,
      backdropDismiss: true,
      cssClass: 'verification-modal modal-fullscreen',
      componentProps: { data: payload },
    });
    return await modal.present();
  }
  getSkuAddonDetailRoaming(skuId){
    this.getSkuAddonDetails(skuId).then((response: any) => {
      if(response && response[0] && response[0].skus && response[0].skus[0] && response[0].skus[0].subgroupType === "TRAVEL_INSURANCE"){
		this.isTravelInsuranceAddon = true;
		this.skuAddonDetails = response[0];
	  }
	  else{
		this.isTravelInsuranceAddon = false;
	  }
	  localStorage.setItem("isTravelInsuranceAddon", this.isTravelInsuranceAddon.toString());
	  localStorage.setItem("skuAddonDetails", JSON.stringify(this.skuAddonDetails))
    })
  }

  async getSkuAddonDetails(skuId){
    const response = await this.SKUDS.getAddonSkuById(skuId)
    .toPromise()
    .catch((e) => this.UTS.log(e));
    return response;
  }

  removeComma(value:String){
    return  parseInt(value.replace(',',''));
  }

  get getCurrentDate(){
    return new Date();
  }

  get lastDate(){
    return new Date(this.getCurrentDate.getFullYear(), this.getCurrentDate.getMonth() + 1, 0);
  }

  get getDays(){
    return this.lastDate.getDate() - this.getCurrentDate.getDate() + 1;
  }

  learnMore(){
    this.openBottomSheet(
      ProRataPricesModalComponent,
      this.proratedData,
      'verification-modal modal-fullscreen'
    );
  }

  getProratedDetails(sku:any){
    this.PS.getProratedDetails(sku && sku?.skuId).subscribe((res:any)=>{
      console.log(res);
      if(res && res.proratedDetails && res.proratedDetails.length > 0){
       this.proratedData = res.proratedDetails || [];
      }
      
     },err=>{
      console.log(err);
     });
  }

  get getCurrentMonth(){
    if (this.lang == 'ar') {
      moment.locale('ar-sa');
      return moment(Date.now()).format('MMM');
    } else {
      moment.locale('en');
      return moment(Date.now()).format('MMM'); // 13th April, 2020
    }
  }

  checkValue(service:any){
    const data = this.proratadValues.find((x:any)=>service?.totalValue && (service?.totalValue == x?.value))
    return data ? data : ''
   }

   

  private isAddonRecommended(skuId): boolean {
    let findRecommendedAddonAvailable = false;
    const ADDON_RECOMMENDATION_LIST = JSON.parse(localStorage.getItem('ADDON_RECOMMENDATION_LIST'));
    if(ADDON_RECOMMENDATION_LIST && ADDON_RECOMMENDATION_LIST?.length > 0){
      findRecommendedAddonAvailable = ADDON_RECOMMENDATION_LIST.find(x => x?.skuId == skuId) ? true : false;
    }
    return findRecommendedAddonAvailable;
  }
  changeTableView(){
  this.openTable = !this.openTable;
  this.cdr.detectChanges();
}
  handleAddonSubscriptionErrors(e){
	this.subscribeDisabled = false
	let eMessage = '';
	this.GAS.onClickDetailsAddon('addons_subscription_fail',this.sku?.displayName,this.sku?.displayName,e?.error?.errorDescription,'GUEST','OTP', this.sku?.id);
	if(e?.error?.errorDescription == AppSettings.ERROR_CRM_016){
		// eligible for free parental addon subscription
		this.openBottomSheet(SuccessComponent, {isFreeParentalEligible: true});
			  return;
	  }
	  if (this.UTS.getLocaleLanguage() == 'en') {
		if (
		  e?.error?.errorDescription == AppSettings.ERROR_RTF_VAL_00080 ||
		  e?.error?.message == AppSettings.ERROR_RTF_VAL_00080 || 
		  e?.error?.newErrorCode == AppSettings.ERROR_RTF_VAL_00080 ||
		  e?.error?.errorDescription == AppSettings.ERROR_VAL_00080 ||
		  e?.error?.message == AppSettings.ERROR_VAL_00080 || 
		  e?.error?.newErrorCode == AppSettings.ERROR_VAL_00080
		) {
		  this.translate.get('ERROR_RTF_VAL_00080').subscribe((message) => {
			eMessage = message;
		  });
		}
		else if (
		  e?.error?.errorDescription == AppSettings.ERROR_RTF_VAL_00015 ||
		  e?.error?.errorDescription == AppSettings.ERROR_VAL_00015
		) {
		  this.translate.get('ERROR_VAL_00015').subscribe((message) => {
			//   this.UTS.error(message);
			eMessage = message;
		  });
		}
		else if (
		  e?.error?.errorDescription == AppSettings.ERROR_VAL_00011 ||
		  e?.error?.message == AppSettings.ERROR_VAL_00011 ||
		  e?.error?.message == AppSettings.ERROR_VAL_00002 ||
		  e?.error?.errorDescription == AppSettings.ERROR_VAL_00002
		) {
		  this.translate.get('ERROR_VAL_00011').subscribe((message) => {
			eMessage = message;
		  });
		} else if (
		  (e?.error && e?.error?.errorDescription && e?.error?.errorDescription.includes(AppSettings.VAL_00011)) ||
		  (e?.error && e?.error?.message && e?.error?.message.includes(AppSettings.VAL_00011)) ||
		  (e?.error && e?.error?.errorDescription && e?.error?.errorDescription.includes(AppSettings.VAL_EAQTY)) ||
		  (e?.error && e?.error?.message && e?.error?.message.includes(AppSettings.VAL_EAQTY)) ||
		  (e?.error && e?.error?.errorDescription && e?.error?.errorDescription.includes(AppSettings.VAL_00061)) ||
		  (e?.error && e?.error?.message && e?.error?.message.includes(AppSettings.VAL_00061)) ||
		  (e?.error && e?.error?.errorDescription && e?.error?.errorDescription.includes(AppSettings.VAL_00133)) ||
		  (e?.error && e?.error?.message && e?.error?.message.includes(AppSettings.VAL_00133)) ||
		  (e?.error && e?.error?.errorDescription && e?.error?.errorDescription.includes(AppSettings.VAL_00013)) ||
		  (e?.error && e?.error?.message && e?.error?.message.includes(AppSettings.VAL_00013))
		) {
		  this.translate.get('ERROR_VAL_00011').subscribe((message) => {
			eMessage = message;
		  });
		} else if (
		  (e.error && e.error.errorDescription && e.error.errorDescription.includes(AppSettings.VAL_E222)) ||
		  (e.error && e.error.message && e.error.message.includes(AppSettings.VAL_E222))
		) {
	
		  this.translate.get('ERROR_VAL_E222').subscribe((message) => {
			eMessage = message;
		  });
		}
		else if(e.error && e.error.errorDescription && e.error.errorDescription == 'ERROR_RTF_CRM-008'){
			const errorObj = this.UTS.searchValidationErrorCode(e.error.errorDescription);
			if(errorObj){
			  eMessage = this.lang === 'ar' ?  this.UTS.convertUnicodeToArabic(errorObj?.errorTextAr): errorObj?.errorTextEn
			}
		}else {
		  eMessage = e?.error?.errorDescription;
		  //   this.UTS.error(e?.error?.errorDescription);
		}
	  } else {
		if (
		  e?.error?.errorDescription == AppSettings.ERROR_RTF_VAL_00080 ||
		  e?.error?.message == AppSettings.ERROR_RTF_VAL_00080 || 
		  e?.error?.newErrorCode == AppSettings.ERROR_RTF_VAL_00080 ||
		  e?.error?.errorDescription == AppSettings.ERROR_VAL_00080 ||
		  e?.error?.message == AppSettings.ERROR_VAL_00080 || 
		  e?.error?.newErrorCode == AppSettings.ERROR_VAL_00080
		) {
		  this.translate.get('ERROR_RTF_VAL_00080').subscribe((message) => {
			eMessage = message;
		  });
		}
		else if (e?.error?.errorDescription == AppSettings.ERROR_VAL_00015) {
		  this.translate.get('ERROR_VAL_00015').subscribe((message) => {
			//  this.UTS.error(message);
			eMessage = message;
		  });
		}
		else if (
		  e?.error?.errorDescription == AppSettings.ERROR_VAL_00011 ||
		  e?.error?.message == AppSettings.ERROR_VAL_00011 ||
		  e?.error?.message == AppSettings.ERROR_VAL_00002 ||
		  e?.error?.errorDescription == AppSettings.ERROR_VAL_00002
		) {
		  this.translate.get('ERROR_VAL_00011').subscribe((message) => {
			eMessage = message;
		  });
		}
		else if (
		  (e?.error && e?.error?.errorDescription && e?.error?.errorDescription.includes(AppSettings.VAL_00011)) ||
		  (e?.error && e?.error?.message && e?.error?.message.includes(AppSettings.VAL_00011)) ||
		  (e?.error && e?.error?.errorDescription && e?.error?.errorDescription.includes(AppSettings.VAL_EAQTY)) ||
		  (e?.error && e?.error?.message && e?.error?.message.includes(AppSettings.VAL_EAQTY)) ||
		  (e?.error && e?.error?.errorDescription && e?.error?.errorDescription.includes(AppSettings.VAL_00061)) ||
		  (e?.error && e?.error?.message && e?.error?.message.includes(AppSettings.VAL_00061)) ||
		  (e?.error && e?.error?.errorDescription && e?.error?.errorDescription.includes(AppSettings.VAL_00133)) ||
		  (e?.error && e?.error?.message && e?.error?.message.includes(AppSettings.VAL_00133)) ||
		  (e?.error && e?.error?.errorDescription && e?.error?.errorDescription.includes(AppSettings.VAL_00013)) ||
		  (e?.error && e?.error?.message && e?.error?.message.includes(AppSettings.VAL_00013))
		) {
		  this.translate.get('ERROR_VAL_00011').subscribe((message) => {
			eMessage = message;
		  });
		} else if (
		  (e.error && e.error.errorDescription && e.error.errorDescription.includes(AppSettings.VAL_E222)) ||
		  (e.error && e.error.message && e.error.message.includes(AppSettings.VAL_E222))
		) {
		  this.translate.get('ERROR_VAL_E222').subscribe((message) => {
			eMessage = message;
		  });
		}
		else if(e.error && e.error.errorDescription && e.error.errorDescription == 'ERROR_RTF_CRM-008'){
			const errorObj = this.UTS.searchValidationErrorCode(e.error.errorDescription);
			if(errorObj){
			  eMessage = this.lang === 'ar' ?  this.UTS.convertUnicodeToArabic(errorObj?.errorTextAr): errorObj?.errorTextEn
			}
		}else {
		  eMessage = e?.error?.errorDescriptionAr;
		  //   this.UTS.error(e?.error?.errorDescriptionAr);
		}
	  }

	  this.SS.addonBuyError.next(eMessage);
          this.SS.addonBuySuccessfully.next({ success: false, data: e });
  }
  
  handleAddonBuySuccess(r: any): any{
	if (r.success == true || r.success == 'true') {
		this.purchase(r.transactionNo, this.price);
		this.SS.addonBuySuccessfully.next({
		  success: true,
		  mobileNumber: this.mobileNumber,
		  price: this.price,
		  billType: this.isATPostpaid
			? 1
			: this.paymentMethod && this.paymentMethod == 2
			  ? 2
			  : 3,
		  data: r,
		});
		if(r?.token){
		  localStorage.setItem('travelInsuranceToken', r?.token);
		}
		let catID = '';
		if(localStorage.getItem('CAT')){
			catID = localStorage.getItem('CAT');
		}
		this.GAS.onSubscribeSuccessAddon(
			'Purchase',
			'Addons',
			this.sku?.productType,
			this.sku?.displayName,
			this.sku?.brand,
			catID,
			this.sku?.id ? this.sku?.id : this.sku?.skuId ? this.sku?.skuId : '',
			this.sku?.validity,
			"WEB",
			this.sku?.listPrice,
			"AED",
			"1"
		);
		this.cdr.detectChanges();
	  } else if (r.reason) {
		this.UTS.error(r.reason);
	  } else {
		this.UTS.error(AppSettings.ERROR);
	  }
  }
  
  createBasketAddons(): any{
    let basketAddons = [];
	let paidPassesIds = localStorage.getItem('paidPassesIds') ? JSON.parse(localStorage.getItem('paidPassesIds')) : [];
    if(this.selectedBogoAddon != null){
      basketAddons.push({'addonId': this.selectedBogoAddon?.skus[0]?.skuId})
    }
	if(paidPassesIds?.length){
		paidPassesIds.forEach(id => {
			basketAddons.push({'addonId': id});
		})
	}
    basketAddons.push({'addonId':this.sku?.skuId});
    return basketAddons;
  }
  changePacks(): void{
	  this.modalController.dismiss();
  }
  /**
* ETWS-689 ETWS-689 || Authorization OTP for Key Transactions start
*/
  subscribeAddon() {
    if (this.EnableAddonsOtpFlow && this.userInfo && this.userInfo?.mainServiceAccountNo) {
      this.enableOTPAutherization();
    }
    else {
      this.subscribeAddoAfterOtp();
    }
  }
  subscribeAddoAfterOtp() {
    this.subscribeDisabled = true
    this.AAS.addToCartEvent("Add to cart", "configure", "order:addons", "add to cart", this.sku);
    if (localStorage.getItem('isRoaming') !== null) {
      this.onCheckoutImpression();

    }
    this.ACCS.getUserInfo().subscribe(
      (res) => {
        if (res && res?.login && res?.loginAccessToken) {
          this.isUserLoggedIn = true;
          this.LoggedIn = true;
          this.cdr.detectChanges();
          localStorage.setItem('isLoggedInSubscribe', 'true');
          this.addAddonLoggedIn()
        } else {
          this.isUserLoggedIn = false;
          this.LoggedIn = false;
          this.userInfo = null;
          this.cdr.detectChanges();
          localStorage.setItem('isLoggedInSubscribe', 'false');
          this.addAddon();
        }
      },
      (e) => {
        localStorage.setItem('isLoggedInSubscribe', 'false');
        this.isUserLoggedIn = false;
        this.LoggedIn = false;
        this.userInfo = null;
        this.cdr.detectChanges();
        this.addAddon();
      }
    );
  }
  async otpVerificationModal(component: any, data?: any, classes = 'verification-modal modal-fullscreen eand-radius-modal') {
    const modal = await this.modalController.create({
      component: component,
      showBackdrop: true,
      componentProps: { data: data },
      cssClass: classes,
    });
    modal.onDidDismiss().then((x: any) => {
      if (x && x?.data && x?.data?.validated) {
        this.subscribeAddoAfterOtp();
      }
    });
    return await modal.present();
  }
  enableOTPAutherization() {
    if (this.isPrimaryAccount) {
      this.otpVerificationModal(OtpVerificationComponent, { type: this.addon, mobileNumber: this.isPrimaryAccount, onlyOTPScreenEnable: true, sku: this.sku, notificationValue: this.notificationValue });

    }
  }
  getPrimaryAccountInfo() {
    this.ACCS.getPrimaryAccountInfo().subscribe(
      (primaryAccountInfo: any) => {
        if (primaryAccountInfo && primaryAccountInfo?.primaryContact) {
          this.accountType(primaryAccountInfo.primaryContact);
        }
        else if (primaryAccountInfo && primaryAccountInfo.responseCode && primaryAccountInfo.responseCode == "0000000" && primaryAccountInfo?.primaryContact == null) {
          this.accountType(this.currentAccount?.accountNo);
        }
      },
      (e) => {
        this.UTS.error(e);
      }
    );
  }
  accountType(accountType: any) {
    this.ACCS.getMobileEligibility(accountType).subscribe(
      (data: any) => {
        //OTP for Elife account autherization
        if (data && data.serviceAccountType && data.serviceAccountType == "Elife") {
          this.isPrimaryAccount = accountType;
          if (data.contactNumber) {
            this.notificationValue = data.contactNumber;
          }
        }
        else { //OTP for prepaid or postpaid account autherization
          this.isPrimaryAccount = accountType;
          this.notificationValue = accountType;
        }
      },
      (e: any) => {
        this.UTS.error(e);
      }
    );
  }
          /**
* ETWS-689 ETWS-689 || Authorization OTP for Key Transactions end
*/

}
